module.exports = __webpack_public_path__ + "media/images/CM-brand-white-fd44060a2875f035f85fc3c2bba03e3a.png";